import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { Agreement } from '@types';

interface AgreementFilterStoreState {
  query: string;
  setQuery: (data: string) => void;
  status: string;
  setStatus: (data: string) => void;
  whiteLabel: string;
  setWhiteLabel: (data: string) => void;
  whiteLabelOptions: any[];
  setWhiteLabelOptions: (data: any[]) => void;
}

export const useAgreementStore = create<AgreementFilterStoreState>()(
  devtools(
    persist(
      (set) => ({
        query: '',
        status: 'ALL',
        whiteLabel: 'ALL',
        whiteLabelOptions: [],
        setQuery: (data) => set({ query: data }),
        setStatus: (data) => set({ status: data }),
        setWhiteLabel: (data) => set({ whiteLabel: data }),
        setWhiteLabelOptions: (data) => set({ whiteLabelOptions: data })
      }),
      {
        name: 'agreements',
        storage: createJSONStorage(() => localStorage)
      }
    )
  )
);

interface AgreementDetailStoreState {
  agreementData: Agreement | null;
  setAgreementData: (data: Agreement | null) => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
}

export const useAgreementDetailStore = create<AgreementDetailStoreState>()(
  devtools(
    persist(
      (set) => ({
        agreementData: null,
        setAgreementData: (data) => set({ agreementData: data }),
        isLoading: false,
        setLoading: (loading) => set({ isLoading: loading }),
        error: null,
        setError: (error) => set({ error })
      }),
      {
        name: 'agreementDetails',
        storage: createJSONStorage(() => sessionStorage)
      }
    )
  )
);